module.exports = __webpack_public_path__ + "static/img/double_fun_shape.7ad23c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/double_fun_shape.png
// module id = maDd
// module chunks = 0